exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hwrld._1yjS-WJEmAdBSwtCbQAs-P {\n  float: left;\n  padding: 20px;\n  width: 100%;\n}\n.hwrld._1yjS-WJEmAdBSwtCbQAs-P ._1aXSQ8dcc3MJu283D_kJG_ {\n  height: 70px;\n  margin: 0 auto 20px;\n  width: 70px;\n}\n.hwrld._1yjS-WJEmAdBSwtCbQAs-P ._31l0kzT10m2stGSO1WDeny {\n  padding: 20px;\n  text-align: center;\n}\n.hwrld._1yjS-WJEmAdBSwtCbQAs-P ._31l0kzT10m2stGSO1WDeny ._2JibsyVTTsTBu92n2rJ2uD {\n  font-size: 28px;\n  margin-bottom: 15px;\n}\n.hwrld._1yjS-WJEmAdBSwtCbQAs-P ._31l0kzT10m2stGSO1WDeny ._1LrcLgHACOZQ3DA8a6WbDo {\n  font-size: 15px;\n}", ""]);

// exports
exports.locals = {
	"hwrld": "_1yjS-WJEmAdBSwtCbQAs-P",
	"spinning-wheel": "_1aXSQ8dcc3MJu283D_kJG_",
	"wrapper": "_31l0kzT10m2stGSO1WDeny",
	"loading-title": "_2JibsyVTTsTBu92n2rJ2uD",
	"loading-text": "_1LrcLgHACOZQ3DA8a6WbDo"
};